import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import MCBody from '@learningblocks/exp-constants/lib/Images/microcentrifuge_body.svg';
import MCLidClosed from '@learningblocks/exp-constants/lib/Images/microcentrifuge_lid_close.svg';
import MCLidOpen from '@learningblocks/exp-constants/lib/Images/microcentrifuge_lid_open.svg';
import {TopSection} from './TopSection';
import {Wrapper} from '../Wrapper';
import {FrontSection} from './FrontSection';

import './style.scss';
import {MCStateContext} from '..';

const TABS = {
  TOP_VIEW: 'TOP_VIEW',
  FRONT_VIEW: 'FRONT_VIEW',
};

export function MCImage(props) {
  const {isLidOpen} = React.useContext(MCStateContext);

  const renderLidOpen = () => (
    <Image
      className='MCImage_lidOpen'
      src={MCLidOpen}
      onClick={props.toggleLid}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );

  const renderLidClosed = () => (
    <Image
      className='MCImage_lidClosed'
      src={MCLidClosed}
      onClick={props.toggleLid}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );

  const onClickTopSection = () => {
    props.setView(TABS.TOP_VIEW);
    props.openModal();
  };
  const onClickFrontSection = () => {
    props.setView(TABS.FRONT_VIEW);
    props.openModal();
  };

  const onMouseEnter = () => {
    props.setHover(true);
  };

  const onMouseLeave = () => {
    props.setHover(false);
  };

  return (
    <Wrapper className='MCImage'>
      {isLidOpen ? renderLidOpen() : renderLidClosed()}
      <div
        className='MCImage_body'
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}>
        <Image className='MCImage_body_image' src={MCBody} alt='MCImage body' />
        {isLidOpen && (
          <TopSection
            onClick={onClickTopSection}
            className='MCImage_body_topSection'
            slots={props.slots}
            onItemDropCentrifuge={props.onItemDropCentrifuge}
          />
        )}
        <FrontSection
          className='MCImage_body_frontSection'
          onClick={onClickFrontSection}
        />
      </div>
    </Wrapper>
  );
}

MCImage.propTypes = {
  /**
   * callback function triggered to toggle lid state
   */
  toggleLid: PropTypes.func,
  /**
   * callback function to open modal
   */
  openModal: PropTypes.func,
  /**
   * callback to set modal view (front view/ top view)
   */
  setView: PropTypes.func,
  /**
   * list of slot information for each slot in microcentrifuge
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * id for unique identification
       */
      id: PropTypes.number,
      /**
       *  specifies if solution is present
       */
      solution: PropTypes.bool,
      /**
       * specfies if rotor is present
       */
      rotor: PropTypes.bool,
    })
  ),
};
